<template>
	<div class="wrapper">
		<div v-if="loading" class="text-center">
			<b-spinner label="Loading..." style="width: 3rem; height: 3rem;" variant="info"></b-spinner>
		</div>
		<div v-else class="animated fadeIn">
			<b-row>
				<b-col cols="12">
					<b-card header-tag="header">
						<template v-slot:header>
							<i class="icon-info"></i> Reseller Information
						</template>
						<b-card-text>
							Name : {{ resellerDetails.name }}
						</b-card-text>
						<b-card-text>
							Code : {{ !resellerDetails.code ? resellerDetails.code : "N/A" }}
						</b-card-text>
						<b-card-text>
							Organization : {{ resellerDetails.organization }}
						</b-card-text>
						<b-card-text>
							Address : {{ resellerDetails.address }}
						</b-card-text>
						<b-card-text>
							Email : {{ !resellerDetails.email ? resellerDetails.email : "N/A" }}
						</b-card-text>
						<b-card-text>
							Phone : {{ !resellerDetails.phone ? resellerDetails.phone : "N/A" }}
						</b-card-text>
						<b-card-text>
							Username : {{ resellerDetails.username }}
						</b-card-text>
					</b-card>
				</b-col>
			</b-row>
			<b-row>
				<b-col cols="12">
					<div class="animated fadeIn">
						<genericTable v-if="projectList.length > 0" :table-data="tableData" :filter="true" :fields="fields" :per-page=50 hover striped bordered small
													caption="<i class='icon-list'></i> Associated Projects"></genericTable>
						<b-col cols="12" v-else>
							<b-card header-tag="header">
								<template v-slot:header>
									<i class="icon-list"></i> Associated Projects
								</template>
								<b-card-text class="text-center">No project is associated with this reseller.</b-card-text>
							</b-card>
						</b-col>
					</div>
				</b-col>
			</b-row>
		</div>
	</div>
<!--	<div>-->
<!--		Reseller ID: {{resellerId}}-->
<!--	</div>-->
</template>

<script>
import genericTable from '@/components/GenericTable';
import resellerService from "@/services/resellerService";
import toastService from "@/services/toastService";
import officeService from "@/services/officeService";
import moment from 'moment';

export default {
	name : "ViewReseller",
	components : {
		"genericTable" : genericTable
	},
	data: function (){
		return {
			resellerId : this.$route.params.resellerId,
			resellerDetails : null,
			projectIdList : [],
			projectList : [],
			projectTableData : [],
			officeList : [],
			fields : [
				{key : 'id', label : 'ID', sortable : true, class: 'text-center', thStyle: 'width: 3%'},
				{key : 'project_name', label : 'Project Name', sortable : true, searchable : true, class: 'text-center', thStyle: 'width: 20%'},
				{key : 'hrm_title', label : 'HRM Title', sortable : true, searchable : true, class: 'text-center', thStyle: 'width: 15%'},
				{key : 'organization', label : 'Organization', class: 'text-center', thStyle: 'width: 20%'},
				{key : 'email', label : 'Email', class: 'text-center', thStyle: 'width: 12%'},
				{key : 'location', label : 'Location', class: 'text-center', thStyle: 'width: 15%'},
				{key : 'creation_date', label : 'HRM Creation Date', class: 'text-center', thStyle: 'width: 10%'},
				{key : 'status', label : 'HRM Status', class: 'text-center', thStyle: 'width: 5%'}
			],
			loading: false
		}
	},
	methods: {
		getResellerDetails: function () {
			this.loading = true;
			resellerService.getResellerDetails(this.resellerId, (data) => {
				this.resellerDetails = data;
				this.projectIdList = this.resellerDetails.projects.filter(item => item.has_client_panel === 1).map(item => item.id);
				this.projectList = this.resellerDetails.projects;
				if(this.projectIdList.length > 0) this.getAssociatedOffices();
				this.loading = false;
			}, (error) => {
				toastService.showErrorToast("Could not fetch reseller details " + error);
				this.loading = false;
			});
		},
		getAssociatedOffices: function () {
			officeService.getOfficesByProjectIdList(this.projectIdList, (data) => {
				this.createProjectListTable(data);
			}, (error) => {
				toastService.showErrorToast("Could not fetch associated office details " + error);
			});
		},
		createProjectListTable : function (officeList) {
			this.projectList.forEach((item) => {
				let row = new Object();
				let office = new Object();
				if(item.has_client_panel === 1) office = officeList.find(o => o.centralServerProjectId === item.id);
				row.id = item.id;
				row.project_name = item.name;
				row.hrm_title = (item.has_client_panel === 1) ? office.clientPanelTitle : "N/A";
				row.organization = item.organization;
				row.email = item.email;
				row.location = item.address;
				row.creation_date = (item.has_client_panel === 1) ? (office.creationDate != null) ? moment(office.creationDate).format('DD-MM-YYYY') : "N/A" : "N/A";
				row.status = (item.has_client_panel === 1) ? office.status : "N/A";
				this.projectTableData.push(row);
			});
		}
	},
	watch: {
		$route(to, from) {
			// this.getResellerDetails();
		}
	},
	created() {
		this.getResellerDetails();
	},
	computed: {
		tableData : function(){
			return this.projectTableData;
		}
	}
}
</script>

<style scoped>

</style>
